function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Container, CssContainer } from "../../components/container";
import { Loader } from "../../components/loaders";
import Auth from "../../functions/authenticate";
import account from "../../data/account";
import endpoints from "../../endpoints";
import { AuthBase } from "../../../plunk/service/auth-base";
import { num } from "../sales/territory-common";

/*
 * Campaign Review queue (CAMPAIGN_APPROVAL_SEND.md §3; mockup
 * campaign-approval.html §2). Plunk account-team surface — Administrator/
 * root only (client-side gate here; the controller enforces
 * GroupAuthorize("Administrator") regardless).
 *
 * ⚠ TOKEN NOTE (probed 2026-08-10): this controller authorizes on the
 * ACCESS token's cognito:groups — the ID token 401s. All calls here use
 * raw fetch with AuthBase.accessToken, not the service layer (which
 * sends the ID token).
 *
 *   GET  /v1/campaign/review-queue                  {tenantManaged, count, items:[{kind, id, name, submittedBy, submittedAt}]}
 *   POST /v1/campaign/ad/campaigns/{id}/approve|reject {reason}
 *   POST /v1/campaign/email/automations/{id}/approve?launch=true|reject
 *
 * Queue is TENANT-SCOPED (one-account-one-tenant): a reviewer sees the
 * submissions of the tenant they're signed into. Approve on email offers
 * "Approve & launch" (?launch=true) per the mockup; ad approve unlocks
 * the fan-out (the worker path checks review_status). E2E-verified live:
 * submit → queue → reject w/ reason → resubmit → approve.
 */

async function call(path, method = "GET", body) {
  const base = endpoints.activity && endpoints.activity.root ? endpoints.activity.root.replace(/\/v1\/activity$/, "") : "";
  const res = await fetch(`${base}/v1/campaign${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (AuthBase.accessToken || ""),
      "x-app-id": (account.get() || {}).tenantId || ""
    },
    body: body !== undefined ? JSON.stringify(body) : undefined
  });
  const text = await res.text();
  let data = {};
  try {
    data = JSON.parse(text);
  } catch (e) {/* non-JSON */}
  if (!res.ok) throw new Error(data.error || data.message || `HTTP ${res.status}`);
  return data;
}
class CampaignReviewComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "act", async (item, action, opts = {}) => {
      const key = `${item.kind}|${String(item.id)}`;
      this.setState({
        busy: {
          ...this.state.busy,
          [key]: true
        }
      });
      const t = document.querySelector("paper-toast");
      // Bulk email campaigns (BULK_EMAIL_MANAGEMENT §5): approve → Approved (the owner
      // schedules from the wizard), reject {reason} → Rejected. Ids are strings end to end.
      const path = item.kind === "email_campaign" ? `/email/campaigns/${String(item.id)}/${action}` : item.kind === "email" ? `/email/automations/${String(item.id)}/${action}${opts.launch ? "?launch=true" : ""}` : `/ad/campaigns/${String(item.id)}/${action}`;
      try {
        await call(path, "POST", action === "reject" ? {
          reason: this.state.reason.trim()
        } : {});
        if (t) t.show(action === "approve" ? opts.launch ? `Approved & launched “${item.name}”.` : `Approved “${item.name}”${item.kind === "ad" ? " — fan-out unlocked." : "."}` : `Rejected “${item.name}” — the client sees the reason.`);
        this.setState({
          rejecting: null,
          reason: ""
        });
        this.load();
      } catch (e) {
        if (t) t.show(e.message || "Action failed.");
      }
      if (this._alive) this.setState({
        busy: {
          ...this.state.busy,
          [key]: false
        }
      });
    });
    this.state = {
      data: null,
      error: "",
      busy: {},
      rejecting: null,
      reason: ""
    };
    this._alive = true;
  }
  async componentDidMount() {
    if (Auth.isAuthenticated() || (await Auth.attachOrSignIn())) this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  isReviewer() {
    return account.inGroup("administrator") || account.inGroup("root");
  }
  async load() {
    try {
      const d = await call("/review-queue");
      if (this._alive) this.setState({
        data: d,
        error: ""
      });
    } catch (e) {
      if (this._alive) this.setState({
        data: {
          items: []
        },
        error: e.message
      });
    }
  }
  render() {
    const {
      data,
      error,
      busy,
      rejecting,
      reason
    } = this.state;
    if (!this.isReviewer()) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "The campaign review queue is a Plunk account-team surface."));
    }
    if (!data) return /*#__PURE__*/React.createElement(Loader, null);
    const items = data.items || [];
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view"
    }, /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, "Campaign Review"), /*#__PURE__*/React.createElement("span", {
      className: "territory-hint",
      style: {
        margin: 0
      }
    }, num(data.count || items.length), " awaiting review \xB7 oldest first")), /*#__PURE__*/React.createElement(Container, {
      css: "margin-squeeze"
    }, error && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        color: "#dc2626"
      }
    }, error), !items.length ? /*#__PURE__*/React.createElement("p", {
      className: "module-empty"
    }, "Queue's clear \u2014 client submissions land here.") : /*#__PURE__*/React.createElement("table", {
      className: "territory-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Submitted"), /*#__PURE__*/React.createElement("th", null, "Kind"), /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "By"), /*#__PURE__*/React.createElement("th", {
      className: "r"
    }))), /*#__PURE__*/React.createElement("tbody", null, items.map(it => {
      const key = `${it.kind}|${String(it.id)}`;
      const b = busy[key];
      const isRejecting = rejecting === key;
      return /*#__PURE__*/React.createElement("tr", {
        key: key
      }, /*#__PURE__*/React.createElement("td", null, it.submittedAt ? String(it.submittedAt).slice(0, 16).replace("T", " ") : "—"), /*#__PURE__*/React.createElement("td", null, it.kind === "email_campaign" ? "Email campaign" : it.kind === "email" ? "Email automation" : "Ad flight"), /*#__PURE__*/React.createElement("td", null, it.kind === "email_campaign" ? /*#__PURE__*/React.createElement("a", {
        href: `/Email/campaigns/detail/${String(it.id)}`,
        onClick: e => {
          e.preventDefault();
          this.props.history.push(`/Email/campaigns/detail/${String(it.id)}`);
        }
      }, /*#__PURE__*/React.createElement("b", null, it.name)) : /*#__PURE__*/React.createElement("b", null, it.name), it.kind === "email_campaign" && it.origin && it.origin !== "plunk" ? /*#__PURE__*/React.createElement("span", {
        className: "cust-stage",
        style: {
          marginLeft: 6
        }
      }, it.origin === "constant_contact" ? "Constant Contact" : it.origin === "mailchimp" ? "Mailchimp" : it.origin, " rail") : null, (it.origin === "autopilot" || it.autopilot) && /*#__PURE__*/React.createElement("span", {
        className: "cust-stage",
        style: {
          background: "#fdeeec",
          color: "#c04a3e",
          marginLeft: 6
        },
        title: "Drafted by Plunk Autopilot \u2014 inside the workspace's guardrails"
      }, "Drafted by Autopilot")), /*#__PURE__*/React.createElement("td", {
        className: "code",
        style: {
          display: "table-cell",
          fontSize: "11px"
        }
      }, it.submittedByEmail || it.submittedBy || "—"), /*#__PURE__*/React.createElement("td", {
        className: "r",
        style: {
          whiteSpace: "nowrap"
        }
      }, isRejecting ? /*#__PURE__*/React.createElement("span", {
        style: {
          display: "inline-flex",
          gap: "6px",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("input", {
        autoFocus: true,
        value: reason,
        placeholder: "Reason the client will see\u2026",
        onChange: e => this.setState({
          reason: e.target.value
        }),
        onKeyDown: e => {
          if (e.key === "Escape") this.setState({
            rejecting: null,
            reason: ""
          });
        },
        style: {
          padding: "5px 8px",
          fontSize: "12px",
          border: "1px solid #d5dbe3",
          borderRadius: "6px",
          width: "260px"
        }
      }), /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle",
        disabled: b || !reason.trim(),
        style: {
          background: "#dc2626",
          color: "#fff",
          borderColor: "#dc2626"
        },
        onClick: () => this.act(it, "reject")
      }, "Reject"), /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle",
        disabled: b,
        onClick: () => this.setState({
          rejecting: null,
          reason: ""
        })
      }, "Cancel")) : /*#__PURE__*/React.createElement("span", {
        style: {
          display: "inline-flex",
          gap: "8px"
        }
      }, /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle",
        disabled: b,
        style: {
          background: "var(--plk-accent, #ff6358)",
          color: "#fff",
          borderColor: "var(--plk-accent, #ff6358)"
        },
        onClick: () => this.act(it, "approve", {
          launch: it.kind === "email"
        })
      }, b ? "…" : it.kind === "email" ? "Approve & launch" : "Approve"), it.kind === "email_campaign" && /*#__PURE__*/React.createElement("span", {
        className: "territory-hint",
        style: {
          margin: 0,
          alignSelf: "center"
        }
      }, "approved \u2192 the owner schedules it"), it.kind === "email" && /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle",
        disabled: b,
        onClick: () => this.act(it, "approve")
      }, "Approve only"), /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle",
        disabled: b,
        onClick: () => this.setState({
          rejecting: key,
          reason: ""
        })
      }, "Reject\u2026"))));
    }))), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        marginTop: "10px"
      }
    }, "Approve on an ad flight unlocks the creation fan-out; true Live state arrives via the status sync \u2014 the client sees \"Launching\u2026\" until the provider echoes. Every action is audit-logged.")));
  }
}
export const CampaignReviewViewComponent = withRouter(CampaignReviewComponent);
export default {
  CampaignReviewViewComponent
};